import { GalleryDto } from '@picflow/types';

export const swapGalleryInUrl = (from: GalleryDto, to: GalleryDto, path: string[], dontUsePath = false) => {
  return path
    .map(p => {
      if (p === from.id) return to.id;
      if (p === from.path && !dontUsePath) return to.path;
      if ('gal_' + p === from.id) return to.id.split('gal_')[1];
      return p;
    })
    .map((p, i) => {
      if (i === 0) return '/' + p;
      return p;
    })
    .filter(p => {
      if (p.startsWith('img_')) return false; // legacy
      if (p.startsWith('ivs_')) return false; // legacy
      if (p.startsWith('asset_')) return false;
      if (p.startsWith('av_')) return false;
      if (p === 'version') return false;
      return true;
    });
};
